import { useEffect } from 'react';
import { filterWidgetEvent } from '@client/foundation/shared/utils/filter-widget-event';
import { useWidget } from '@client/widgets/widget.hook';
import { WidgetPayload } from '@client/widgets/widget.types';
import { useWindow } from '@client/window/window.hook';

export const useStrategyTemplateEditorEvents = () => {
  const { openWidget$ } = useWidget();
  const { openWindow } = useWindow();

  useEffect(() => {
    const subscription = openWidget$()
      .pipe(
        filterWidgetEvent<WidgetPayload, 'StrategyTemplateEditor'>(
          'StrategyTemplateEditor'
        )
      )
      .subscribe((payload) => {
        openWindow({
          type: 'StrategyTemplateEditor',
          sx: {
            maxWidth: 'lg',
            width: '90%',
            height: '93%'
          },
          componentProps: {
            templateId: payload.templateId,
            initialName: payload.initialName,
            initialStrategy: payload.initialStrategy,
            onSaved: payload.onSaved
          }
        });
      });

    return () => subscription.unsubscribe();
  }, [openWidget$, openWindow]);
};
